export default __webpack_public_path__ + "static/media/coming-soon.cee28e0b.png";